import React, { useLayoutEffect, useRef } from "react";
import { fullMonthFormatDate, signedLockedAccess } from "../../../../utils";
import style from "./assessmentNotes.module.scss";
import { PERMISSIONS } from "../../../../constants/permissions";
import { TextArea } from "../../../primary";
import { CANCEL_BTN, SAVE_BTN } from "../../../../constants";
import { FormActions } from "../../../secondary/FormActions/FormActions";

export const NoteItem = ({
  data,
  assessmentStage,
  onDelete,
  hasPermission,
  onEdit,
  isEditing,
  onCancelEdit,
  onSaveEdit,
  editedNote,
  onEditChange,
  onKeyDown,
  updateNoteLoading,
}) => {
  const textAreaRef = useRef(null);

  useLayoutEffect(() => {
    if (isEditing && textAreaRef.current) {
      const el = textAreaRef.current;
      el.focus();

      const length = el.value.length;
      el.setSelectionRange(length, length);
    }
  }, [isEditing]);
  return (
    <div className={style.entered_notes}>
      <div className="d-flex justify-content-between align-items-center">
        <div className={style.post_details}>
          <span className={style.creater_name}>{data.createdBy}</span> | <span>{fullMonthFormatDate(data.createdDate)}</span> |{" "}
          <span>{data.createdByRole}</span>
        </div>

        <div className="d-flex gap-2">
          <button
            data-testid="editNote"
            className={`btn ${style.edit_icon}`}
            type="button"
            onClick={() => onEdit(data)}
            disabled={!signedLockedAccess(assessmentStage) || !hasPermission(PERMISSIONS.ASSESSMENT_NOTE_DELETE)}
          >
            <i className="fa fa-pencil" />
          </button>

          <button
            data-testid="deleteNote"
            className={`btn ${style.delete_icon}`}
            type="button"
            onClick={() => onDelete(data)}
            disabled={!signedLockedAccess(assessmentStage) || !hasPermission(PERMISSIONS.ASSESSMENT_NOTE_EDIT)}
          >
            <i className="fa fa-trash fa-lg" />
          </button>
        </div>
      </div>

      <div className={style.notes_text}>
        {isEditing ? (
          <>
            <TextArea
              id="edit-textarea"
              validator={textAreaRef}
              classes={{ inputClassName: style.textarea_box }}
              value={editedNote}
              onChange={onEditChange}
              onKeyDown={onKeyDown}
              rows={3}
            />

            <FormActions
              primaryLabel={SAVE_BTN}
              primaryId="edit-submit-btn"
              primaryType="button"
              primaryLoading={updateNoteLoading}
              onPrimaryClick={() => onSaveEdit(data.id)}
              secondaryLabel={CANCEL_BTN}
              secondaryId="edit-cancel-btn"
              onSecondaryClick={onCancelEdit}
            />
          </>
        ) : (
          (data.notes || "Unknown").split("\n").map((line, i) => <div key={i}>{line}</div>)
        )}
      </div>
    </div>
  );
};
